import { FC } from "react";
import { Link } from "react-router-dom";
import { Href } from "../../../constants";
import { useAppDispatch, useAppSelector } from "../../../reduxToolkit/hooks";
import { setSidebarOpen } from "../../../reduxToolkit/reducers/layoutSlice";
import { routes } from "../../../routers/routes";
import { HeaderType } from "../../../types/Layout";
import { dynamicImage, Image } from "../../../utils";
import CityDropdown from "./CityDropdown";

const Location: FC<HeaderType> = ({ part, isJobOrProperty }) => {
  const dispatch = useAppDispatch();
  const { sidebarOpen } = useAppSelector((state) => state.layout);

  return (
    <div className="left-side-header">
      <a href={Href} className={`toggle ${sidebarOpen ? "open" : ""}`} onClick={() => dispatch(setSidebarOpen(!sidebarOpen))}>
        <i className="ri-menu-line" />
      </a>
      <Link to={routes.Home.CarDemo1} className="header-logo">
        <Image src={dynamicImage(`logo/${part?.includes("property-2") ? "2" : "1"}.png`)} alt="logo" className="img-fluid" />
      </Link>
      {!isJobOrProperty && <CityDropdown />}
    </div>
  );
};

export default Location;
